import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import getLang from 'I18n/utils/getLang';
const serviceCatalogBase = 'service-catalog/public/v1';
export const fetchServices = () => noAuthApiClient.get(`${serviceCatalogBase}/services?language=${getLang()}`);
export const fetchEnglishServices = () => noAuthApiClient.get(`${serviceCatalogBase}/services?language=en`);